/* eslint-disable padding-line-between-statements */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
// Process drivers using high-level entity - ratedDriverList
const processDrivers = (props) => {
    if (!props.ratedDriverList) {
        return props;
    }

    const drivers = props.ratedDriverList.reduce((acc, driver, index) => {
        acc[`driver${index + 1}`] = driver;
        return acc;
    }, {});

    props.drivers = drivers;
    delete props.ratedDriverList;
    return props;
};

// Process vehicles using high-level entity - vehiclesToDisplay
const processVehicles = (props) => {
    if (!props.vehiclesToDisplay) {
        return props;
    }
    const vehicles = props.vehiclesToDisplay.reduce((acc, vehicle,index) => {
        acc[`vehicle${index + 1}`] = vehicle;
        return acc;
    }, {});
    
    props.vehicles = vehicles;
    delete props.vehiclesToDisplay;
    return props;
};

const processValidation = (submissionVM, props) => {
    props.priorInsurance = submissionVM?.lobData?.personalAuto?.questionSets_ML?.priorInsurance?.answers?.value;
    props.houseAdditionalInformation = submissionVM?.lobData?.personalAuto?.questionSets_ML?.houseAdditionalInformation?.value;
    props.discrepancies = submissionVM?.hvqDiscrepancies_ML?.personalAuto?.value;
    props.lineModifiers = submissionVM.lobData.personalAuto.modifiers_ML?.lineModifiers?.value; 
    let vehicles = submissionVM.lobData.personalAuto.coverables.vehicles?.value;
    if (vehicles) {
        vehicles = vehicles.reduce((acc, vehicle, index) => {
            acc[`vehicle${index + 1}`] = {
                name: vehicle?.displayName,
                parkingType: vehicle?.parkingType_ML,
            };
            return acc;
        }, {});
        props.vehiclesParking = vehicles;
    }
    
    return props;
};

// Process coverages using high-level entities:
// submissionVM.lobData.personalAuto.offerings.value[0].coverages and submissionVM.quoteData.offeredQuotes.value[0]
const processCoverages = (submissionVM, props) => {
    const coverages = submissionVM?.lobData?.personalAuto?.offerings?.value[0]?.coverages;
    const offering = submissionVM?.quoteData?.offeredQuotes?.value[0];

    let optionalCoverages = coverages?.optionalCoverages;
    if (optionalCoverages !== undefined) {
        optionalCoverages = optionalCoverages.reduce((acc, coverage) => {
            if (coverage?.selected == true && coverage?.hasTerms == true) {
                acc[coverage.name] = {
                    limit: coverage?.terms[0]?.chosenTermValue
                };
            }
            return acc;
        }, {});
    };

    const lineCoverages = coverages?.lineCoverages.reduce((acc, coverage) => {
        if (coverage?.selected == true) {
            if (coverage?.amount?.amount.toFixed(2) === undefined) {
                acc[coverage.name] = {
                    limit: coverage?.terms[0]?.chosenTermValue
                };
            } else {
                acc[coverage.name] = {
                    limit: coverage?.terms[0]?.chosenTermValue,
                    amount: '$' + coverage?.amount?.amount.toFixed(2),
                };
            }
        }
        return acc;
    }, {});

    const vehicleCoverages = coverages?.vehicleCoverages.reduce((acc, vehicle, index) => {
        acc[`vehicle${index + 1}`] = {
            vehicle_cost_monthly: '$' + vehicle?.vehicleMonthlyCost_ML?.amount.toFixed(2) + '/month',
            vehicle_cost_total: '$' + vehicle?.vehicleCost_ML?.amount.toFixed(2),
            coverages: vehicle?.coverages?.reduce((innerAcc, coverage, innerIndex) => {
                if (coverage?.selected == true) {
                    innerAcc[`coverage${innerIndex + 1}`] = {
                        name: coverage?.name,
                        limit: coverage?.terms[0]?.chosenTermValue
                    };
                };
                return innerAcc;
            }, {})
        };
        return acc;
    }, {});
    
    const allCoverages = {
        optionalCoverages: optionalCoverages,
        lineCoverages: lineCoverages,
        vehicleCoverages: vehicleCoverages,
        offering: offering
    };

    props.allCoverages = allCoverages;
    return props;
};

const getCoveragePackageLevel = (submission) => {
    if (!submission.bindData?.value?.chosenQuote) {
        return undefined
    }

    const chosenQuote = submission.quoteData.value.offeredQuotes.find((offering) => {
        return offering.publicID === submission.bindData.value.chosenQuote
    });

    return chosenQuote.coveragePackageLevel_Ext;
}

const PATrackEvent = (eventName, isSkipping, submissionVM, user, props, isQnB) => {
    try {
        if (eventName === 'Quote Step Submitted' || eventName === 'Issuance Step Submitted' ) {
            sessionStorage.setItem('userSubmitAction', true);
            sessionStorage.setItem('userSubmitted', new Date());
            if (!isSkipping && sessionStorage.getItem('pageLoaded')) {
                const pageLoadTime = new Date(sessionStorage.getItem('pageLoaded'));
                const userSubmitTime = new Date();
                props.user_spent_time = (userSubmitTime - pageLoadTime) / 1000;
                sessionStorage.setItem('lastAction', props.action);
            }
        }
        if (eventName === 'Quote Step Reached' || eventName === 'Issuance Step Reached' || eventName === 'Quote Purchased' ) {
            if (!isSkipping) {
                sessionStorage.setItem('pageLoaded', new Date());
                if (sessionStorage.getItem('userSubmitAction') && sessionStorage.getItem('userSubmitted')) {
                    const userSubmitTime = new Date(sessionStorage.getItem('userSubmitted'));
                    const pageLoadTime = new Date();
                    props.system_load_time = (pageLoadTime - userSubmitTime) / 1000;
                    sessionStorage.setItem('userSubmitAction', false);
                    sessionStorage.setItem('lastStep', props.step);
                }
            }
        }
        if (submissionVM.lobData.personalAuto.coverables !== undefined &&
            submissionVM.lobData.personalAuto.coverables.drivers.value.length > 0) {
            let accidents = 0;
            for (let i=0; i < submissionVM.lobData.personalAuto.coverables.drivers.value.length; i++) {
                if (submissionVM.lobData.personalAuto.coverables.drivers.value[i].disclosures_ML !== undefined) {
                    accidents += submissionVM.lobData.personalAuto.coverables.drivers.value[i].disclosures_ML.accidents.length;}
            }
            let violations = 0;
            for (let i=0; i < submissionVM.lobData.personalAuto.coverables.drivers.value.length; i++) {
                if (submissionVM.lobData.personalAuto.coverables.drivers.value[i].disclosures_ML !== undefined) {
                    violations += submissionVM.lobData.personalAuto.coverables.drivers.value[i].disclosures_ML.violations.length;}
            }
            let claims = 0;
            for (let i=0; i < submissionVM.lobData.personalAuto.coverables.drivers.value.length; i++) {
                if (submissionVM.lobData.personalAuto.coverables.drivers.value[i].disclosures_ML !== undefined) {
                    claims += submissionVM.lobData.personalAuto.coverables.drivers.value[i].disclosures_ML.claims.length;}
            }
            props.no_of_drivers = submissionVM.lobData.personalAuto.coverables.drivers.value.length;
            props.no_of_vehicles = submissionVM.lobData.personalAuto.coverables.vehicles.value.length;
            props.accidents = accidents;
            props.violations = violations;
            props.claims = claims;
            if (submissionVM.lobData.personalAuto.questionSets_ML.priorInsurance.answers.value.CurrentInsuranceProvider_ML !== null) {
                const prior_insurance = submissionVM.lobData.personalAuto.questionSets_ML.
                    priorInsurance.answers.value.CurrentInsuranceProvider_ML;
                if (prior_insurance !== undefined) {
                    props.prior_insurance_carrier = prior_insurance.replace('CurrentInsuranceProvider','');}
            }
        }

        if (props.step == 'Drivers Screen' || props.action == 'Drivers Submitted' || props.step == 'Prefill Results' || props.action == 'Prefill Results Submitted') {
            props = processDrivers(props);
        }

        if (props.step == 'Vehicles Screen' || props.action == 'Vehicles Submitted' || props.step == 'Prefill Results' || props.action == 'Prefill Results Submitted') {
            props = processVehicles(props);
        }

        if (props.step == 'Gateway CompRater Validation Page' || props.action == 'CompRater Auto Validation Page Submitted'){
            props = processValidation(submissionVM, props);
        }

        if (props.step == 'Quote Page' || props.action == 'Quote Submitted') {
            props = processCoverages(submissionVM, props);
        }

        props.quote_type = sessionStorage.getItem('quoteType');
        props.pol_state = submissionVM.baseData.value.policyAddress.state;
        if (!isQnB) {
            props.user_type = user.userTypeName_ML;
            props.agent_id = user.userName_ML;
        }
        props.gpc_code = submissionVM.baseData.value.gafInfo_ML !== undefined ? submissionVM.baseData.value.gafInfo_ML.gpcCode : undefined ;
        if (!props.gpc_code && !_.isEmpty(sessionStorage.getItem('gpcCode'))) { 
            props.gpc_code = sessionStorage.getItem('gpcCode');
        }


        props.isPFMReturned = submissionVM.baseData.isPFMReturned_ML.value;
        props.pfm_no_hit = submissionVM.baseData.pfmLevel_ML.value === ('NF'||'NK'||'NN'||'NQ') ? true : undefined ;
        props.app_name = (isQnB) ? 'Quote and Buy' : 'Producer Engage';
        props.app_parent = 'Agent360';
        props.lob = 'Auto';
        props.quote_publicId = submissionVM.quotePublicId.value;
        props.isCompRater = submissionVM.hvqDiscrepancies_ML.value !== undefined ;
        props.compRaterVendorName = _.get(submissionVM, 'compRaterVendorName_ML.value', '');
        props.quoteID = submissionVM.quoteID?.value;
        props.bundleIndicator = (submissionVM.isBundle_ML && submissionVM.isBundle_ML.value) || (isQnB && sessionStorage.getItem('IsBundle') === 'true') ? 'Y': 'N';
        props.qnb_source_id = submissionVM.baseData?.directConsumerSource_Ext?.value;
        
        window.analytics.track(eventName, props);
        
        if (eventName === 'Quote Step Reached' || eventName === 'Issuance Step Reached' || eventName === 'Quote Purchased' ) {
            const pageProps = {
                state: props.pol_state,
                lob: props.lob,
                priorCarrier: (props.prior_insurance_carrier) ? props.prior_insurance_carrier : undefined,
                bundleIndicator: props.bundleIndicator,
                producerCode: submissionVM.producerCodeOfRecord_ML.code?.value,
                zip: submissionVM.baseData.value.policyAddress.postalCode,
                pfm: submissionVM.baseData.value.pfmLevel_ML,
                productType: getCoveragePackageLevel(submissionVM),
                quoteID: props.quoteID,
                isCompRater: props.isCompRater 
            };

            const category = (eventName === 'Quote Step Reached') ? 'Quote Page' : 'Issuance Page';

            window.analytics.page(category, props.step, pageProps);

            if (!isQnB) {

                try {
                    window.analytics.identify(user.userName_ML, {
                        name: user.displayName,
                        email: user.email,
                        producercode: user.primaryProducerCode_ML?.code,
                        userType: user.userTypeName_ML,
                        pc_username: user.userName_ML,
                        groupName: user.affiliatedGroup_ML?.groupName,
                        login : user.loginID,
                        IAPortalId: user.portalId,
                        pol_state: props.pol_state,
                        lob: props.lob,
                        isCompRater: props.isCompRater ,
                        quoteID: props.quoteID,
                        bundleIndicator: props.bundleIndicator,
                        app_page: props.step,
                        Agent_Segment: user.primaryProducerCode_ML?.producerLevel,
                        Transaction_Type: eventName,
                        PolicyNumber: undefined,
                        PolicyNumbers: undefined,
                        lobs: undefined,
                        pol_states: undefined
                    });
                } catch (e) {
                    console.error(`Segment error calling identify API: ${e.message}`);
                }
            }
        }

        sessionStorage.setItem('segmentProps', JSON.stringify(props));
    } catch (e) {
        console.error(`Segment Error in PA Track Event: ${e.message}`);
    }
};

export default PATrackEvent ;